var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as locales from 'date-fns/locale';
import { DEFAULT_LOCALE, VALID_LOCALES } from '../constants';
var localeMap = Object.values(locales).reduce(function (acc, locale) {
    var _a;
    return (locale.code && VALID_LOCALES.includes(locale.code) ? __assign(__assign({}, acc), (_a = {}, _a[locale.code] = locale, _a)) : acc);
}, {});
var localeCodeToLocale = function (code) { return (code ? localeMap[code] || DEFAULT_LOCALE : DEFAULT_LOCALE); };
export default localeCodeToLocale;
